import React from "react";
import "./InstaFeed.css"

const InstaHead = () => {
  return (
    <div className="instaHeadContainer">
      <h6>Customer Experience</h6>
      <div className="instaUnderline"></div>
    </div>
  );
};

export default InstaHead;
